var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2V2.28988C12.8915 3.15043 15 5.82898 15 9V14C15.5523 14 16 14.4477 16 15C16 15.5523 15.5523 16 15 16H1C0.447715 16 0 15.5523 0 15C0 14.4477 0.447715 14 1 14V9C1 5.82898 3.10851 3.15043 6 2.28988V2C6 0.89543 6.8954 0 8 0C9.1046 0 10 0.89543 10 2ZM3 14H13V9C13 6.23858 10.7614 4 8 4C5.23858 4 3 6.23858 3 9V14ZM10 16H6C6 17.1046 6.8954 18 8 18C9.1046 18 10 17.1046 10 16Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.c2c893299d6f059bb1e1337eae61f090.svg";
export { ForwardRef as ReactComponent };